module.exports = __webpack_public_path__ + "img/2.c43cfd54.png";